import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { loyaltyFormSchema } from './loyalty-points-form.schema';

export const useLoyaltyForm = () => {
  const form = useForm({
    resolver: yupResolver(loyaltyFormSchema),
    defaultValues: loyaltyFormSchema.cast({}),
  });

  return { form };
};
